import { RenderModal } from "../Functions/RenderModal";

(function ($) {
    /*
    Shows external videos in a modal on product galleries
     */
    $(document).on('click', '.product-gallery .image-thumbnail', function (e) {
        const productGallery = e.target.closest('.product-gallery');
        const mainImage = productGallery.querySelector('.main-image');

        $(productGallery).find('.video-thumbnail').removeClass('active');
        mainImage.classList.remove('shows-video');
    });

    $(document).on('click', '.product-gallery .video-thumbnail', function (e) {
        const productGallery = e.target.closest('.product-gallery');
        const mainImage = productGallery.querySelector('.main-image');

        mainImage.classList.add('shows-video');
        $(productGallery).find('.video-thumbnail').removeClass('active');
        e.target.closest('.video-thumbnail').classList.add('active');
    });

    $(document).on('click', '.product-gallery .main-image.shows-video .openseadragon', function (e) {
        const productGallery = e.target.closest('.product-gallery');
        const activeVideo = productGallery.querySelector('.video-thumbnail.active');

        if (activeVideo) {
            const identifier = activeVideo.dataset.identifier;
            const videoplayer = document.querySelector('#' + identifier);

            RenderModal.init('', videoplayer.innerHTML);
        }
    });
})(jQuery);
